<script lang="ts">
	import type { Component } from 'svelte';

	const {
		label,
		Icon,
		value
	}: {
		label: string;
		Icon: Component;
		value: string;
	} = $props();
</script>

<div class="flex flex-col gap-1">
	<span class="flex items-center gap-1 text-xs font-bold tracking-widest opacity-70">
		<Icon />
		{label.toUpperCase()}
	</span>
	<span class="text-xl font-black">{value}</span>
</div>
